import React, { createContext, useContext } from 'react';

const AuthContext = createContext();

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children, accessToken }) => {
  return <AuthContext.Provider value={{ accessToken }}>{children}</AuthContext.Provider>;
};
